<ng-container [formGroup]="fg">
  <label class="checkbox-contianer flex-centered">
    <input type="checkbox" [formControl]="fc" id="acc-checkbox">
  </label>
  <label for="acc-checkbox">
    <ng-content></ng-content>
  </label>
</ng-container>